import React from 'react';
import { Navigate } from 'react-router-dom';
import RoutePath from './Routing/RoutePath';

function Home() {
    return <Navigate to={RoutePath.Assessments} />;
}
export default Home;
